import { contactFormSection, finalCTASection, mapSection, testimonialsSection } from "../sections/individualSections";

const CONTACT_SECTIONS = [contactFormSection, mapSection, testimonialsSection, finalCTASection];

export default CONTACT_SECTIONS.map((s, idx) => ({ ...s, order: idx + 1 }));
